<template>
  <TopNav></TopNav>
  <h1>Salary to Hourly Wage Calculator</h1>
  <fieldset>
    <legend>Salary to Hourly Wage Calculator</legend>
    <label for="a">Monthly salary: </label> <input type="number" v-model.number="monthlySalary" id="a" step="any">
    <br>
    <label for="b">Hours worked per week: </label> <input type="number" v-model.number="hoursPerWeek" id="b" step="any">
    <br><br>
    Hourly wage: <span class="blue">{{ hourlyWage() }}</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "SalaryToHourly",
  data() {
    return {
      monthlySalary: 0,
      hoursPerWeek: 40
    }
  },
  components: {
    TopNav
  },
  methods: {
    hourlyWage: function () {
      let hoursPerMonth = this.hoursPerWeek * 4;
      return this.monthlySalary / hoursPerMonth;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 225px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
